export default __webpack_public_path__ + "static/media/exest.800486e5.svg";